<div>
    <div class="setting-field-content">
        <button tam-button tamType="tertiary" tamSize="normal" *ngFor="let item of fieldArray"
            class="template-field-button" (click)="fieldContextMenu($event,item)"
            [disabled]="item.isDisable">{{item.name}}</button>
    </div>
    <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
</div>